
declare var gGDPR_logoURL: string;

declare var gGDPR_privacyPolicyURL: string;
declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Emit, Component, Prop, Vue } from "vue-facing-decorator";
import { TCModel } from "@iabtcf/core";
import { ampLogInfo } from "@/util";

@Component
export default class LayerOne extends Vue {

	privacyPageURL = "";
  forcedFixedPosition = false;
  logo_URL = typeof gGDPR_logoURL  == "string" ? gGDPR_logoURL : "";
  features : any[] = [] 
  stacks : any[] = [] 
  partnerCount:any = "";

	mounted(): void {
    this.privacyPageURL = typeof gGDPR_privacyPolicyURL  == "string" ? gGDPR_privacyPolicyURL : "";

		//@ts-ignore
		let model: TCModel = window.__cmpTCModel;

    if ( model && model.gvl ) {
      //@ts-ignore
      this.features = model.gvl.specialFeatures;
      this.stacks = [ model.gvl.purposes["1"], model.gvl.stacks["42"] ];
      this.partnerCount = Object.keys( model.gvl.vendors ).length.toString();

      //@ts-ignore
    } else if ( model && model.specialFeatures ) {
		  //@ts-ignore
      this.features = model.specialFeatures;
		  //@ts-ignore
      this.stacks = [ model.purposes["1"], model.stacks["42"] ];
    }

	}

  @Emit('changeViewEvent')
  manageSettingsClick(): string {
    return 'layerTwo'
		// this.$emit("changeViewEvent", "layerTwo");
	}

  @Emit('changeViewEvent')
  vendorsClick(): string {
    return 'layerThree'
    //this.$emit("changeViewEvent", "layerThree");
	}

  @Emit('changeViewEvent')
	acceptAllClick(): string {

    console.log("GPP: Accept All Clicked");
//@ts-ignore
		this.$root.storeAcceptAllTCString();
    return 'close'
		// this.$emit("changeViewEvent", "close");
	}

  @Emit
	storeAcceptAllTCString() { }

  @Emit
	storeRejectAllTCString() { }
  
  @Emit
	storeTCString() { }

  
}
